export const generalFeedbackQuestion = "General Feedback";